import { View, Text } from "react-native";
import React from "react";
import { useGetUsers } from "clients/apis";
import {
  AnimatedInfinityList,
  Empty,
  Error,
  Header,
  Loading,
  UserCard,
} from "components";
import { sizes, strings } from "assets/constants";
import css from "styles";

const Users = () => {
  const {
    isError,
    error,
    isRefetching,
    refetch,
    isLoading,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useGetUsers();

  const _renderItem = (item: any) => {
    return (
      <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
        {item?.items?.data?.map((user: UserT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <UserCard user={user} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.items?.data?.length === 0) {
      return <Empty message={strings.no_company} />;
    }

    return (
      <AnimatedInfinityList
        onRefresh={refetch}
        responseData={data}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        renderItemList={_renderItem}
        paddingTop={sizes.space}
      />
    );
  };

  return (
    <>
      <Header title={strings.users} />
      <>{_renderContent()}</>
    </>
  );
};

export default Users;
